import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import BookingTransactionListPage from './BookingTransactionList';
import BookingTransactionModalPage from './BookingTransactionModal';
import './BookingTransaction.css';

@inject(
    'loginStore',
    'BookingTransactionStore'
)
@observer
class BookingTransactionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    }

    // ON CANCEL

    bookingTransactionModalOnCancel = () => {
        this.props.BookingTransactionStore.setShowBookingTransactionModal(false);
    }

    render() {
        const {
            showBookingTransactionModal,
            bookingTransactionTitle,
        } = this.props.BookingTransactionStore;

        return (
            <MainContainer title='Booking Transaction' menukey='booking-transaction'>
                <Modal
                    title={bookingTransactionTitle}
                    visible={showBookingTransactionModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingTransactionModalOnCancel}
                    zIndex={1000}
                >
                    <BookingTransactionModalPage />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <BookingTransactionListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default BookingTransactionPage;
